import ObjectPivotWrapper from "./object-pivot-wrapper.js";

const tmpVec = new THREE.Vector3();

class TransformControlsWrapper {
    constructor(trCtrl, pivotGetter) {
        this._trCtrl = trCtrl;
        this._objWrap = new ObjectPivotWrapper();
        this._object = null;
        this._pivotGetter = pivotGetter;

        this._cbWrap = new WeakMap();
        this._evtWrap = new WeakMap();

        this._proxyHandler = {
            set: (object, property, value, receiver) => false,
            deleteProperty: (object, property) => false,
            get: (object, property, receiver) => {
                const value = object[property];

                if (property === "object") {
                    return value === this._objWrap ? this._object : null;
                } else {
                    return value;
                }
            },
        };
    }

    get object() {
        return this._object;
    }

    get visible() { return this._trCtrl.visible; }
    set visible(visible) { this._trCtrl.visible = visible; }
    get setTranslationSnapCallback() { return this._trCtrl.setTranslationSnapCallback; }
    get setRotationSnapCallback() { return this._trCtrl.setRotationSnapCallback; }

    attach(object) {
        this._object = object;
        const pivot = this._pivotGetter.getObjectPivot(object, tmpVec);
        this._objWrap.setObjectAndPivot(object, pivot);
        this._trCtrl.attach(this._objWrap);
    }

    detach() {
        this._trCtrl.detach();
        this._objWrap.setObjectAndPivot();
        this._object = null;
    }

    getMode() { return this._trCtrl.getMode(); }
    setMode(mode) { return this._trCtrl.setMode(mode); }
    update() { return this._trCtrl.update(); }

    traverse(callback) { return this._trCtrl.traverse(callback); }

    addEventListener(name, callback) {
        const cbWrap = this._getCallbackWrapper(callback, true);
        this._trCtrl.addEventListener(name, cbWrap);
    }

    removeEventListener(name, callback) {
        const cbWrap = this._getCallbackWrapper(callback, false);

        if (cbWrap) {
            this._trCtrl.removeEventListener(name, cbWrap);
        }
    }

    _getCallbackWrapper(callback, createIfMissing = false) {
        let cbWrap = this._cbWrap.get(callback);

        if (!cbWrap) {
            cbWrap = (event) => {
                const evtWrap = this._getEventWrapper(event);
                callback(evtWrap);
            };

            this._cbWrap.set(callback, cbWrap);
        }

        return cbWrap;
    }

    _getEventWrapper(event) {
        let evtWrap = this._evtWrap.get(event);

        if (!evtWrap) {
            evtWrap = new Proxy(event, this._proxyHandler);
            this._evtWrap.set(event, evtWrap);
        }

        return evtWrap;
    }
}

export default TransformControlsWrapper;
